import React, {FC} from 'react'

import successImage from '../images/successImage.png'

type Props ={
    Course?:any,
    Showsuccess: boolean,
    onClose:()=>void
}

export const RoadmapSuccess:FC<Props> = ({ Course ,Showsuccess, onClose}) => {
    
        if (!Showsuccess) return null; 

return (
    <>
  <div className="fixed z-[900] inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4">
    <div className="bg-[#ffffff] rounded-[20px] max-w-[500px] shadow-lg w-[95%] sm:w-full md:w-[500px] max-h-[90vh] overflow-auto relative">
      
      <div className="rounded-t-[20px]  p-6  h-[60px] bg-[#047711] flex items-center justify-center">
        <h2 className="text-[17px] px-4  text-center  md:text-[20px] lg:text-[26px] xl:text-[26px] font-[800] text-white">Email Successfully Sent...</h2>
      </div>

      
      <button onClick={ onClose}  className="absolute top-3 right-3 text-[#ffffff] text-lg">✖</button>

      
      <div className="flex flex-col justify-center px-8 items-center pt-14 pb-24">
        <div className="bg-[#047711] rounded-full p-6">
          <img className="h-[100px] w-[100px] sm:w-[65px] sm:h-[65px]" src={successImage} alt="success" />
        </div>
        <div className="text-[20px] font-[600] text-[#047711] mt-4 text-center">
          <p>The {Course?.CourseName} roadmap has been successfully sent to your email.</p>
        </div>
      </div>
    </div>
  </div>
        </>
    )
}